
      import { TENPRINT } from "./src/embeddable/background-element.ts";

      const svg = document.getElementById("rotatoImage");

      if (svg === null) {
        throw new Error("Couldn't find rotato");
      }

      TENPRINT(
        svg,
        {
          gridSize: 50,
          firstColour: "#E7AF18",
          secondColour: "#ECBF46",
        },
        {
          saveSeed: "svg-element-seed",
        },
      );
    